// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__A7lqB","dark":"Page_dark__1I1xZ","primary":"Page_primary__389bH","content":"Page_content__1d0Vb","breakout":"Page_breakout__3C1R3"};